import { defineMessages } from 'react-intl';

/* eslint-disable max-len */

export default defineMessages({
  reviewCount: {
    id: 'report.rating.reviewCount',
    description: 'Review count',
    defaultMessage: 'arviointia',
  },
  rating_overall: {
    id: 'report.rating.ratingOverall',
    description: 'Overall rating',
    defaultMessage: 'Yleisarvosana',
  },
  rating_price: {
    id: 'report.rating.ratingPrice',
    description: 'Value for money rating',
    defaultMessage: 'Vastine rahalle',
  },
  rating_quality: {
    id: 'report.rating.ratingQuality',
    description: 'Quality rating',
    defaultMessage: 'Laatuarvosana',
  },
  rating_thumbs: {
    id: 'report.rating.ratingThumbs',
    description: 'Thumbs up rating',
    defaultMessage: 'Palvelun sujuvuus',
  },
  notYetRated: {
    id: 'report.rating.notYetRated',
    description: 'Company has not been rated yet, be first to rate!',
    defaultMessage: 'Yritystä ei vielä ole arvioitu. Ole ensimmäinen!',
  },
  loginZeckit: {
    id: 'report.rating.loginZeckit',
    description: 'Login with Zeckit',
    defaultMessage: 'Kirjaudu Zeckitillä',
  },
  showAllReviews: {
    id: 'report.rating.showAllReviews',
    description: 'Show all reviews',
    defaultMessage: 'Näytä kaikki arvioinnit',
  },
  saveReview: {
    id: 'report.rating.saveReview',
    description: 'Save review',
    defaultMessage: 'Tallenna arviointi',
  },
  newReview: {
    id: 'report.rating.newReview',
    description: 'Submit new review',
    defaultMessage: 'Anna arviointi',
  },
  editReview: {
    id: 'report.rating.editReview',
    description: 'Edit existing review',
    defaultMessage: 'Muuta arviointiasi',
  },
  thankForReviewing: {
    id: 'report.rating.thankForReviewing',
    description: 'Thank for reviewing',
    defaultMessage: 'Kiitos arvioinnistasi!',
  },
  loginDisclaimer: {
    id: 'report.rating.loginDisclaimer',
    description: 'Explains why login is required',
    defaultMessage:
      'Palvelun perustana on läpinäkyvyys ja luotettavuus. Tämän vuoksi edellytämme tunnistautumista arvioinneissa. Tunnistautumisen ansiosta voit myös nähdä ja muuttaa omia arviointejasi myöhemmin. Emme julkaise sähköpostia arvion yhteydessä, näytämme ainoastaan arvioijan etunimen ja mahdollisen profiilikuvan. Yritys voi ottaa palvelun kautta anonyymisti yhteyttä arvioijaan. Tunnistautuminen lisää luotettavuutta arviointeihin.',
  },
});
